import cookie from 'react-cookies';
import {handleSelectionOptions} from "./selection.options";
import {isEmpty} from "@helpers/helpers";
import {getCitiesLists, getCity, getCityById, setDefaultCity} from "../../models/district";

const storage_key = 'cities_lists';

export const getDefaultCity = (full = false) => {
    const default_id = 259;
    let city_id = cookie.load('default_city_id');

    if (isEmpty(city_id)) {
        city_id = default_id
    }

    if (full && process.browser) {
        let cityInfo = null;
        let localStorageDefaultCity = localStorage.getItem('default_city');

        if (!isEmpty(localStorageDefaultCity)) {
            localStorageDefaultCity = JSON.parse(localStorageDefaultCity);

            if(!isEmpty(localStorageDefaultCity) && localStorageDefaultCity.id === city_id) {
                cityInfo = localStorageDefaultCity;
            }
        }

        if (isEmpty(cityInfo)) {
            cityInfo = getCity(city_id);

            if (!isEmpty(cityInfo)) {
                setDefaultCity(city_id);
            }
        }

        return cityInfo;
    }

    return city_id;
};


const getOptions = () => {
    return new Promise((resolve, reject) => {
        getCities();

        function getCities() {
            getCitiesLists().then(result => {
                resolver(result);
            }).catch(err => {
                setTimeout(() => {
                    getCities();
                }, 500)
            });
        }

        function resolver(result) {
            const {cities} = result;
            const items = handleSelectionOptions(cities);
            const options = items.options;

            resolve({options, selected_items: items.selected_items});
        }
    });
};

export const citiesSelection = async () => {
    return await getOptions().then(items => {
        return {
            options: items.options,
            selected_items: items.selected_items,
        };
    });
};

